import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import {
  SALES_CUSTOMER_CARE_SCOPE,
  type SalesCustomerCareScope,
} from '~/scopes/care-commons/utils/logger/salesCustomerCare/config'
import { useSalesCustomerCareLogger } from '~/scopes/care-commons/utils/logger/salesCustomerCare/useSalesCustomerCareLogger'

export function useResolution({
  resolutionId,
  scope = SALES_CUSTOMER_CARE_SCOPE.contactConfirmationPage,
}: {
  resolutionId: string
  scope?: SalesCustomerCareScope
}) {
  const $httpFetch = useHttpFetch()
  const { logHttpError } = useSalesCustomerCareLogger()

  return $httpFetch('/resolution-engine/resolutions/:resolutionId', {
    pathParams: {
      resolutionId,
    },
    onResponseError: ({ response }) => {
      if (response) {
        logHttpError({
          // eslint-disable-next-line no-underscore-dangle
          error: response._data,
          errorStatusCode: response.status,
          errorTitle: `${scope} Error when fetching associated resolution for resolutionId:${resolutionId}`,
        })
      }
    },
  })
}
